















































import Vue, { VueConstructor } from "vue";
import { createComponent, computed } from "@vue/composition-api";
import {
  Decision,
  decisionResource,
  DecisionState,
} from "@megarax/client/src/resources/Decision";
import { IncompleteResourceItem } from "@megarax/client/src/resources/ResourceItem";
import DecisionCardBody from "./DecisionCardBody.vue";
import DecisionCardHeader from "./DecisionCardHeader.vue";
import { useActions, useMegaraxClient } from "@/shared/useMegaraxClient";
import { useAsyncRef } from "@/shared/useAsyncRef";
import { useResourceProvider } from "../../../shared/useResourceProvider";
import { meResource } from "@megarax/iam/restApi";

interface Props {
  value: Decision;
}

export default createComponent<Props>({
  components: {
    DecisionCardBody,
    DecisionCardHeader,
  },
  props: {
    value: {
      required: true,
    },
  },
  setup(props, ctx) {
    const decisionActions = useActions(decisionResource);
    const meResourceProvider = useResourceProvider(meResource);

    const canResolveDecision = useAsyncRef<boolean>(() =>
      meResourceProvider.isAllowed({
        action: "management.decision.approve",
      }),
    );

    function updateDecision(updated: Decision) {
      Object.assign(props.value, updated);
    }

    const showDeleteButton = computed(() => {
      if (props.value.state !== DecisionState.awaiting) return false;
      if (!props.value.createdBy) return false;
      return props.value.createdBy.id === useMegaraxClient().user!.id;
    });

    const showDecisionButtons = computed(
      () =>
        props.value.state === DecisionState.awaiting &&
        canResolveDecision.value,
    );

    const showFooter = computed(
      () => showDeleteButton.value || showDecisionButtons.value,
    );

    return {
      decisionActions,
      updateDecision,
      showDeleteButton,
      showDecisionButtons,
      showFooter,
    };
  },
});
